import axios from "axios";
import { toast } from "react-toastify";
import HelperService from "./HelperService";

//Development
const BASE_URL = process.env.REACT_APP_BASE_URL;

interface PropData {
  action: string;
  body?: any;
  isFormData?: boolean;
  isShowError?: boolean;
  isProductData?: boolean;
  canIgnoreAdminEndpoint?: boolean;
  id?: string;
  _file?: File;
  key?: string;
}

const GetBaseUrl = (canIgnore: boolean, url: any) => {
  return canIgnore ? url?.replace("/admin", '') : url;
}

let isGlobalErrorShown = false
let globalErrorTimeout: any = null

const WebService = {
  postAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      var bodyFormData = new FormData();
      if (props.isFormData) {
        for (let key in props.body) {
          let d = props.body[key];
          if (Array.isArray(d)) {
            d.forEach((el: any, i: any) => {
              if (props.isProductData) {
                bodyFormData.append(key + `[${i}][id]`, el.id);
                bodyFormData.append(key + `[${i}][type]`, el.type);
              } else {
                bodyFormData.append(key + `[${i}]`, el);
              }
            });
          } else {
            bodyFormData.append(key, d);
          }
        }
      }
      const headers = {
        "Content-Type": props.isFormData ? "multipart/form-data" : "application/json",
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        appid: localStorage.getItem("app_id"),
        xapikey: localStorage.getItem("p_user_id"),
      };
      axios
        .post(
          `${BASE_URL}${props.action}`,
          props.isFormData ? bodyFormData : props.body,
          {
            headers: headers,
          }
        )
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error && error.response && error.response.status == 401) {
            this.logout();
          }

          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },
  uploadAPI: function (props: PropData) {
    let formData = new FormData();

    if (props._file && props.key) {
      formData.append(props.key, props._file);
    }

    if (props.body) {
      for (let key in props.body) {
        formData.append(key, props.body[key]);
      }
    }

    return new Promise((resolve, reject) => {
      const headers = {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      };

      axios
        .post(`${BASE_URL}${props.action}`, formData, { headers })
        .then((response) => resolve(response.data))
        .catch((error) => {
          if (error?.response?.status == 401) this.logout();
          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  downloadFileAPI(props: PropData) {
    return new Promise((resolve, reject) => {
      const { body, isFormData, action } = props;
      const headers = {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      };
      const bodyFormData = new URLSearchParams();
      if (isFormData) {
        for (let key in body) {
          bodyFormData.append(key, body[key]);
        }
      }
      axios.get(`${BASE_URL}${action}`, {
        headers: {
          ...headers,
          Accept:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error?.response?.status === 401) {
            WebService.logout();
          }
          props.isShowError
            ? reject(error)
            : reject(WebService.errorHandler(error));
        });
    });
  },
  putAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      var bodyFormData = new FormData();
      if (props.isFormData) {
        for (let key in props.body) {
          bodyFormData.append(key, props.body[key]);
        }
      }

      const headers = {
        "Content-Type": props.isFormData ? "multipart/form-data" : "application/json",
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        appid: localStorage.getItem("app_id"),
        xapikey: localStorage.getItem("p_user_id"),
      };
      axios
        .put(`${BASE_URL}${props.action}`, props.body, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error && error.response && error.response.status == 401) {
            this.logout();
          }

          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },


  patchAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      var bodyFormData = new FormData();
      if (props.isFormData) {
        for (let key in props.body) {
          bodyFormData.append(key, props.body[key]);
        }
      }

      const headers = {
        "Content-Type": props.isFormData ? "multipart/form-data" : "application/json",
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        appid: localStorage.getItem("app_id"),
        xapikey: localStorage.getItem("p_user_id"),
      };
      axios
        .patch(`${BASE_URL}${props.action}`, props.body, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error && error.response && error.response.status == 401) {
            this.logout();
          }

          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },
  getAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        appid: localStorage.getItem("app_id"),
      };
      const URL = GetBaseUrl(props?.canIgnoreAdminEndpoint ?? false, BASE_URL);
      axios
        .get(`${URL}${props.action}`, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error && error.response && error.response.status == 401) {
            this.logout();
          }

          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  deleteAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        appid: localStorage.getItem("app_id"),
      };
      axios
        .delete(`${BASE_URL}${props.action}`, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error && error.response && error.response.status == 401) {
            this.logout();
          }

          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  errorHandler(error: any) {
    if (error?.response) {
      error = error.response;
    }
    let errorMessage;
    if (!error || !error.status) {
      errorMessage = "Server Not Responding";
    } else if (error.status === 401) {
      errorMessage = "Unauthorized";
      WebService.logout();
    } else if (error.status === 500) {
      errorMessage =
        error?.data?.ErrorDetails?.message ||
        "An unknown exception has occurred. Please contact administrator";
    } else {
      errorMessage = error.data?.message || "Something went wrong";
    }
    const isGlobalIssue =
      !error?.status || error?.status >= 500 || error?.status === 0;

    if (isGlobalIssue) {
      if (!isGlobalErrorShown) {
        isGlobalErrorShown = true;
        toast.error(errorMessage);

        globalErrorTimeout = setTimeout(() => {
          isGlobalErrorShown = false;
        }, 5000);
      }
    } else {
      toast.error(errorMessage);
    }
    return errorMessage;
  },

  addLoader(id?: any, status?: any) {
    if (id) {
      let button = document.getElementById(id) as HTMLButtonElement | null;
      if (button) {
        button.disabled = true;
        let loader = document.createElement("span");
        loader.innerHTML =
          '<span style="margin-right:5px" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span className="visually-hidden"></span>';
        button.prepend(loader);
      }
    }
  },

  removeLoader(id: any) {
    if (id) {
      let button = document.getElementById(id) as HTMLButtonElement | null;
      if (button != null) {
        button.disabled = false;
        button.removeChild(button.childNodes[0]);
      }
    }
  },

  logout() {
    localStorage.clear();
    window.location.href = "/login";
  },
};

export default WebService;
